import React from "react";
import { IJob } from "./interfaces";
import { formatString } from "./utils";

const Details = ({
  job,
  setActiveId,
}: {
  job: IJob;
  setActiveId: React.Dispatch<React.SetStateAction<string | null>>;
}) => {
  return (
    <tr>
      <td colSpan={3} className="p-0">
        <div className="table-detail">
          <div className="details-top">
            <div>
              <small>{formatString(`${job?.model}`)}</small>
              <span></span>
            </div>
          </div>
          <div className="summary">
            <span className="tag">Summary</span>
            <div>
              <label htmlFor="total-questions-in-file">
                Total Questions in File
              </label>
              <input
                type="text"
                id="total-questions-in-file"
                value={job.total_questions}
              />
            </div>
            <div>
              <label htmlFor="total-categorized-in-file">
                Total Categorized Questions
              </label>
              <input
                type="text"
                id="total-categorized-in-file"
                value={job.processed_questions}
              />
            </div>
            <div>
              <label htmlFor="total-uncategorized-in-file">
                Total Uncategorized Questions
              </label>
              <input
                type="text"
                id="total-questions-in-file"
                value={job.failed_questions}
              />
            </div>
          </div>
          <div className="details-status">
            <span className="tag">Status</span>
            <div>
              <input
                type="text"
                id="total-questions-in-file"
                value={job.status}
              />
            </div>
          </div>
          <div className="details-bottom">
            <button onClick={() => setActiveId(null)}>Close</button>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default Details;
